import { render, staticRenderFns } from "./privacystatement.vue?vue&type=template&id=387668c0&scoped=true&"
import script from "./privacystatement.vue?vue&type=script&lang=js&"
export * from "./privacystatement.vue?vue&type=script&lang=js&"
import style0 from "./privacystatement.vue?vue&type=style&index=0&id=387668c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387668c0",
  null
  
)

export default component.exports